import React, { useEffect, useState } from 'react';
import { InformationChip } from '@europrocurement/flexy-components';
import { Typography } from '@mui/material';
import { type DossierArticle, useStatusStyle } from '@europrocurement/l2d-modules';

import { DossierArticleProcessMenuItemProps } from '../DossierArticleProcessMenu/DossierArticleProcessMenu';

export type DossierArticleProcessStatusProps = {
    statusLabel: string;
    statusFlag: number;
    getItemActions?: (article: DossierArticle) => Array<DossierArticleProcessMenuItemProps>;
    article?: DossierArticle;
};

const DossierArticleProcessStatus: React.FunctionComponent<DossierArticleProcessStatusProps> =
    function (props) {
        const { statusLabel, statusFlag, getItemActions = () => [], article } = props;
        const [cliquable, setCliquable] = useState<boolean>(false);

        const { getValidatorStatusStyle } = useStatusStyle();
        const { iconProp, sxStatus } = getValidatorStatusStyle(statusFlag);

        const [actionClick, setActionClick] = useState<(article?: DossierArticle) => void>(
            () => {},
        );

        // check if the "update status validator is available in the actions"
        useEffect(() => {
            if (article && getItemActions) {
                const itemsActions = getItemActions(article);
                if (itemsActions) {
                    const updateValidatorAction = itemsActions.find(
                        (action) => action.label === 'Modifier le statut valideur',
                    );

                    if (updateValidatorAction && article) {
                        setCliquable(true);
                        setActionClick(() => updateValidatorAction.onClick);
                    }
                }
            }
        }, [getItemActions, article]);

        const handleClick = () => {
            if (article && actionClick) {
                actionClick(article);
            }
        };

        return (
            <InformationChip
                sx={{
                    ...sxStatus,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: cliquable ? 'pointer' : 'default',
                }}
                sxIcon={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                icon={iconProp}
                label={
                    <Typography
                        onClick={handleClick}
                        variant="l2dbodys"
                    >
                        {statusLabel}
                    </Typography>
                }
            />
        );
    };

export default DossierArticleProcessStatus;
